if(!customElements.get('vertical-testimonials')){
    class Testimonials extends HTMLElement{
        constructor(){
            super();
        }

        connectedCallback(){
            const header = document.querySelector('custom-header');
            if(header){
                const headerHeight = header.offsetHeight;
                this.style.setProperty('--heading-block-top', `${headerHeight}px`);
            }
        }
    }

    customElements.define('vertical-testimonials', Testimonials);
}